import { useQuery } from '@tanstack/react-query';
import { getTechPerformanceContext } from '../services/TechnicianPerformanceService';
import { iimReviewKeys } from './queryKeys';
export function useTechPerformanceContext(technicianId, inspectionId, enabled) {
    return useQuery({
        queryKey: iimReviewKeys.techPerformanceContext(technicianId, inspectionId),
        queryFn: () => getTechPerformanceContext(technicianId, inspectionId),
        enabled,
        staleTime: 5 * 60 * 1000
    });
}
